import type { PermissionRole, Permissions } from '@wix/wix-data-schema-types'

const legacyRoleByPermissionRole: Record<PermissionRole, string> = {
  admin: 'siteOwner',
  siteMember: 'siteMember',
  siteMemberAuthor: 'dataOwner',
  anyone: 'anonymous',
}

export const toLegacyRole = (role: PermissionRole | undefined) =>
  role ? legacyRoleByPermissionRole[role] : undefined

export const serializePermissions = (permissions: Permissions) =>
  JSON.stringify({
    read: toLegacyRole(permissions.read),
    insert: toLegacyRole(permissions.insert),
    update: toLegacyRole(permissions.update),
    remove: toLegacyRole(permissions.remove),
  })
